<template>
  <div>
    <XVactionbar v-if="pagesettings.btnToevoegenSetting !== null">
      <template slot="actionbuttons">
        <button type="button" id="butToevoegen" class="btn btn-primary btn-xs" @click="btnToevoegen">
          <font-awesome-icon icon="plus" />
          {{ translation(6506) }}
        </button>
      </template>
    </XVactionbar>
    <div class="row margin20">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ pagesettings.lblTitel }}</span>
      </div>
    </div>
    <div class="row margin20" v-if="$route.params.personid !== undefined">
      <div class="col-md-12">
        <template id="beheertabs">
          <div class="row inactiveDossierLink visibileTab0adm" v-if="pagesettings.hypProfDetail_NavigateUrl !== null">
            <div class="col-md-12">
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a id="hypProfDetail" :href="pagesettings.hypProfDetail_NavigateUrl">{{ translation(334) }}</a>
            </div>
          </div>
          <div
            class="row inactiveDossierLink visibileTabProfMsgadm"
            v-if="pagesettings.hypProfMsg_NavigateUrl !== null"
          >
            <div class="col-md-12">
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a id="hypProfMsg" :href="pagesettings.hypProfMsg_NavigateUrl">{{ translation(12339) }}</a>
            </div>
          </div>
          <div
            class="row inactiveDossierLink visibileTab1adm"
            v-if="pagesettings.hypStatusoverzicht_NavigateUrl !== null"
          >
            <div class="col-md-12">
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a id="hypStatusoverzicht" :href="pagesettings.hypStatusoverzicht_NavigateUrl">{{ translation(3510) }}</a>
            </div>
          </div>
          <div class="row inactiveDossierLink visibileTab2adm" v-if="pagesettings.hypActiviteiten_NavigateUrl !== null">
            <div class="col-md-12">
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a id="hypActiviteiten" :href="pagesettings.hypActiviteiten_NavigateUrl">{{ translation(3511) }}</a>
            </div>
          </div>
          <div class="row inactiveDossierLink visibileTab3adm" v-if="pagesettings.hypMutatie_NavigateUrl !== null">
            <div class="col-md-12">
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a id="hypMutatie" :href="pagesettings.hypMutatie_NavigateUrl">{{ translation(3512) }}</a>
            </div>
          </div>
          <div class="row activeDossierLink visibileTab4adm" v-if="pagesettings.hypMutatie_NavigateUrl !== null || pagesettings.hypActiviteiten_NavigateUrl !== null || pagesettings.hypStatusoverzicht_NavigateUrl !== null || pagesettings.hypProfMsg_NavigateUrl !== null || pagesettings.hypProfDetail_NavigateUrl !== null">
            <div class="col-md-12">
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <label id="lblMSF">{{ translation(10367) }}</label>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <span id="lblinfo" v-html="pagesettings.lblSubtitel"></span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <XVtableV2
          :filterfunc="filterfunc"
          :tablesetting="msfTable.tablesetting"
          :tablecolumnsetting="msfTable.tablecolumnsetting"
          :tabledata="msfTable.tabledata"
          :rowvisible="msfTable.rowvisible"
          v-on:sortXVTable="XVTablesort"
          :paging="true"
          :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
        >
          <template slot="tblMSFverwijder" slot-scope="dr" v-if="wLG === true || wXL === true">
            <span :id="'verwijder_' + [dr.index]" class="delMSF" :title="translation(150)" @click="openConfirm(dr)">
              <font-awesome-icon :icon="['fa', 'trash']" class="initial pointer" v-if="dr.celldata === 1" />
            </span>
          </template>
          <template slot="tblMultiSourceFeedbackDateCreated" slot-scope="dr">
            <span v-if="dr.row.tblMultiSourceFeedbackIDLink">
              <a :href="'/' + dr.row.tblMultiSourceFeedbackIDLink">{{ dr.celldata }}</a>
            </span>
          </template>
          <template slot="formSetName" slot-scope="dr">
            <span v-if="dr.row.formSetName">
              <a :href="'/' + dr.row.tblMultiSourceFeedbackIDLink">{{ dr.celldata }}</a>
            </span>
          </template>
          <template slot="tblMultiSourceFeedbackDateEnd" slot-scope="dr">
            <span class="tcEndDate">{{ dr.celldata }}</span>
          </template>
          <template slot="detailrow" slot-scope="tablerow">
            <div class="margin20"></div>
            <div class="row" v-show="MDvisible" v-if="tablerow.row.formSetName">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(9376) }}</label>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback">
                <span>
                  <a :href="'/' + tablerow.row.tblMultiSourceFeedbackIDLink">{{ tablerow.row.formSetName }}</a>
                </span>
              </div>
            </div>
            <div class="row" v-show="MDvisible">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(6509) }}</label>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback">
                {{ tablerow.row.tblMultiSourceFeedbackDateStart }}
              </div>
            </div>
            <div class="row" v-show="MDvisible">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(6510) }}</label>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback">
                {{ tablerow.row.tblMultiSourceFeedbackDateEnd }}
              </div>
            </div>
            <div class="row" v-show="SMvisible" v-if="tablerow.row.status">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(6511) }}</label>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback">
                <span>{{ tablerow.row.status }}</span>
              </div>
            </div>
            <button
              :id="'btnVerwijder' + tablerow.index"
              type="button"
              class="btn btn-primary XVtablerowbutton margin20bottom"
              @click.prevent="openConfirm(tablerow)"
              v-if="(wXS === true || wSM === true || wMD === true) && tablerow.row.tblMSFverwijder === 1"
            >
              <font-awesome-icon :icon="['fa', 'trash']" />
              {{ translation(150) }}
            </button>
          </template>
        </XVtableV2>
      </div>
    </div>
    <modal v-model="showConfirm" title="Modal 1" ref="modal" id="modal-demo" :header="false">
      <p v-html="deletemsg"></p>
      <div slot="footer" class="modalconfirmbuttons">
        <button
          id="btnDeleteModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="deleteConfirm()"
        >
          {{ translation(23) }}
        </button>
        <button
          id="btnCloseModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="closeConfirm"
        >
          {{ translation(17) }}
        </button>
      </div>
    </modal>
  </div>
</template>


<script>
'use strict'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
// URL naar beheer https://pe.xaurum.nl/peapp/allroles/620262/SPE696PatientEnquete
// URL naar prof https://pe.xaurum.nl/peapp/allroles/SPE696PatientEnquete

export default {
  mixins: [FAMixin],
  data: function () {
    return {
      showConfirm: false,
      selectedRowID: 0,
      deletemsg: '',
    }
  },
  async mounted() {
    this.spe696getTexten()
    if (this.$route.params.personid !== undefined) {
      this.setPersonid(this.$route.params.personid)
    } else {
      this.setPersonid(0)
    }
    await this.getPagesettings(this.personid)
    this.stopLoading()
  },
  computed: {
    ...mapGetters('SPE696PatientEnquete', ['pagesettings', 'personid', 'msfTable']),
    SMvisible() {
      if (this.wXS || this.wSM) {
        return true
      } else {
        return false
      }
    },
    MDvisible() {
      if (this.wXS || this.wSM || this.wMD) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    ...mapActions('SPE696PatientEnquete', ['getPagesettings', 'spe696getTexten', 'deleteRow']),
    ...mapMutations('SPE696PatientEnquete', [
      'setPersonid',
      'XVTablesort',
      'XVtablecolumnsettingchanged',
      'XVtableSetRowStateProperty',
    ]),
    btnToevoegen() {
      window.location = this.pagesettings.btnToevoegenSetting
      // window.open(this.pagesettings.btnToevoegenSetting)
    },
    filterfunc(tabledata) {
      return tabledata
    },
    openConfirm: function (tablerow) {
      if (tablerow.row.tblMultiSourceFeedbackDateStart !== '') {
        this.deletemsg = this.translation(9597)
      } else {
        this.deletemsg = this.translation(14828)
      }
      this.showConfirm = true
      this.selectedRowID = tablerow.row.tblMultiSourceFeedbackID
    },
    closeConfirm: function () {
      this.showConfirm = false
    },
    deleteConfirm: function () {
      this.deleteRow(this.selectedRowID)
      this.showConfirm = false
    },
  },
}
</script>
